"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.1.5'] && _();
}
catch (e) { }
